import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../helpers/UseAuth';

export const GuardedRoutes = () => {
    const auth = useAuth();
    return auth?.user
        ? <Outlet />
        : <Navigate to="/login" />;
}

